// extracted by mini-css-extract-plugin
export default {"logoutContainer":"logout-container__logout-container__D_BH6"};